const step = document.getElementsByClassName("step");
const prevBtn = document.getElementById("prev-btn");
const nextBtn = document.getElementById("next-btn");
const submitBtn = document.getElementById("submit-btn");
const continueBox = document.getElementById("q-box__buttons");
const form = document.getElementsByTagName("form")[0];
const bodyElement = document.querySelector("body");
const inputRadio = document.querySelectorAll('input[type="radio"]');
const firstname = document.getElementById("first_name");
const lastname = document.getElementById("last_name");
const phone = document.getElementById("phone");
const email = document.getElementById("email");
const zip = document.getElementById("zip");
let steps = [1, 0, 0, 0, 0, 0, 0];
let stepCheck = [];
let currentId = [""];
const continueBtn =
  '<button id="next-btn" class="btn btn-lg btn-primary rounded-pill px-5 py-3 w-100">Continue</button>';

// form.onsubmit = () => {
//   return false
// }
let current_step = 0;
let stepCount = 8;
step[current_step].classList.add("d-block");
if (current_step == 0) {
  prevBtn.classList.add("disabled");
}

const progress = (value) => {
  document.getElementsByClassName("progress-bar")[0].style.width = `${value}%`;
};

nextBtn.addEventListener("click", () => {
  // const divsDirectsDansForm = div.querySelectorAll('div > section');
  // divsDirectsDansForm.classList.add('show');
  //alert('maman');
  //event.preventDefault();
  // setTimeout(function() {
  console.log('next Btn Clicked');
  current_step++;
  let previous_step = current_step - 1;
  if (current_step > 0 && current_step <= stepCount) {
    prevBtn.classList.remove("disabled");
    step[current_step].classList.remove("d-none");
    step[current_step].classList.add("d-block");
    step[previous_step].classList.remove("d-block");
    step[previous_step].classList.add("d-none");
    if (current_step > 1) {
      step[current_step].style.animation =
        "fade-in-from-right 0.5s ease-in-out forwards";
    }
    if (current_step == stepCount - 1) {
      nextBtn.classList.remove("d-inline-block");
      nextBtn.classList.add("d-none");
    }
  } else {
    if (current_step > stepCount) {
      form.onsubmit = () => {
        return true;
      };
    }
  }
  progress((100 / stepCount) * current_step);

  if (steps[current_step] === 0) {
    continueBox.style.display = "none";
  }
  // }, 3000);
});

prevBtn.addEventListener("click", () => {
  console.log('prevBtn Clicked');
  if (current_step > 0) {
    current_step--;
    let previous_step = current_step + 1;
    step[current_step].classList.remove("d-none");
    step[current_step].classList.add("d-block");
    step[current_step].style.animation =
      "fade-in-from-left 0.5s ease-in-out forwards";
    step[previous_step].classList.remove("d-block");
    step[previous_step].classList.add("d-none");
    if (current_step < stepCount - 1) {
      nextBtn.classList.remove("d-none");
      nextBtn.classList.add("d-inline-block");
    }
  }

  if (current_step == 0) {
    prevBtn.classList.add("disabled");
    progress(10);
  } else {
    progress((100 / stepCount) * current_step);
  }

  if (steps[current_step] === 1) {
    continueBox.style.display = "block";
  }
});

/************ Verify phone number and email ***********/
document
  .getElementById("submit-btn")
  .addEventListener("click", function (event) {
    // Validate the phone number field
    var phoneNumberInput = document.getElementById("phone");
    var phoneNumber = phoneNumberInput.value;
    var phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

    var emailInput = document.getElementById("email");
    var email = emailInput.value;
    var emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    current_step++;
    let previous_step = current_step - 1;
    //if ((current_step > 0) && (current_step == stepCount)) {

    if (!emailRegex.test(email)) {
      current_step--;

      if (!phoneRegex.test(phoneNumber)) {
        phoneNumberInput.classList.add("invalid-input-phone");
        event.preventDefault();
      }
      else{
        phoneNumberInput.classList.remove("invalid-input-phone");
      }

      emailInput.classList.add("invalid-input-email");
      event.preventDefault();
    } else {
      step[current_step].classList.remove("d-none");
      step[current_step].classList.add("d-block");
      step[previous_step].classList.remove("d-block");
      step[previous_step].classList.add("d-none");
      progress((100 / stepCount) * current_step);
      emailInput.classList.remove("invalid-input-email");
    }
  });
/******************************************/

// Interactive displaying continue button
// run this function whenever the values of any of inputs change.
// this is to check if the input for all is valid.  if so, enable button.
// otherwise, disable it.
const current_checked = document.querySelectorAll('input[type="radio"]');
current_checked.forEach((element) => {
  element.addEventListener("click", (e) => {
    if (
      element.checked &&
      stepCheck.length == current_step &&
      currentId[current_step] == e.target.id
    ) {
      element.checked = false;
      steps[current_step] = 0;
      continueBox.style.display = "none";
    } else {
      steps[current_step] = 1;
      continueBox.style.display = "block";
    }
    stepCheck = document.querySelectorAll('input[type="radio"]:checked');
    currentId[current_step] = e.target.id;
  });
});

//last form
const checkEnableButton = () => {
  //submitBtn.disabled = false;

  submitBtn.disabled = !(
    firstname.value &&
    lastname.value &&
    phone.value &&
    email.value &&
    zip.value
  );
};

firstname.addEventListener("input", checkEnableButton);
lastname.addEventListener('input', checkEnableButton);
phone.addEventListener('input', checkEnableButton);
email.addEventListener("input", checkEnableButton);
zip.addEventListener("input", checkEnableButton);

// nextBtn.addEventListener('load', () => {
//   const divsDirectsDansForm = form.querySelectorAll('div > section');
//   divsDirectsDansForm.classList.add('show');
// });

/*/=======================================================================================//
               Animation Pause
//=======================================================================================*/

//First Circle Variables
var moncercleC1 = document.querySelector(".moncercleC1");
var moncercleC2 = document.querySelector(".moncercleC2");
var moncercleC3 = document.querySelector(".moncercleC3");
var moncercleC4 = document.querySelector(".moncercleC4");
//Second Circle Variables
var moncercleS1 = document.querySelector(".moncercleS1");
var moncercleS2 = document.querySelector(".moncercleS2");
var moncercleS3 = document.querySelector(".moncercleS3");
var moncercleS4 = document.querySelector(".moncercleS4");
//Third Circle Variables
var moncercleP1 = document.querySelector(".moncercleP1");
var moncercleP2 = document.querySelector(".moncercleP2");
var moncercleP3 = document.querySelector(".moncercleP3");
var moncercleP4 = document.querySelector(".moncercleP4");
//Fourth Circle Variables

//Circle Animation Function
function startAnimation() {
  //First Circles
  moncercleC1.style.animationIterationCount = "1";
  moncercleC1.addEventListener("animationend", function () {
    moncercleC1.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleC1.style.animationIterationCount = "infinite";
      moncercleC1.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleC2.style.animationIterationCount = "1";
  moncercleC2.addEventListener("animationend", function () {
    moncercleC2.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleC2.style.animationIterationCount = "infinite";
      moncercleC2.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleC3.style.animationIterationCount = "1";
  moncercleC3.addEventListener("animationend", function () {
    moncercleC3.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleC3.style.animationIterationCount = "infinite";
      moncercleC3.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleC4.style.animationIterationCount = "1";
  moncercleC4.addEventListener("animationend", function () {
    moncercleC4.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleC4.style.animationIterationCount = "infinite";
      moncercleC4.style.animationPlayState = "running";
    }, 5000);
  });

  //Second Circles
  moncercleS1.style.animationIterationCount = "1";
  moncercleS1.addEventListener("animationend", function () {
    moncercleS1.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleS1.style.animationIterationCount = "infinite";
      moncercleS1.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleS2.style.animationIterationCount = "1";
  moncercleS2.addEventListener("animationend", function () {
    moncercleS2.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleS2.style.animationIterationCount = "infinite";
      moncercleS2.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleS3.style.animationIterationCount = "1";
  moncercleS3.addEventListener("animationend", function () {
    moncercleS3.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleS3.style.animationIterationCount = "infinite";
      moncercleS3.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleS4.style.animationIterationCount = "1";
  moncercleS4.addEventListener("animationend", function () {
    moncercleS4.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleS4.style.animationIterationCount = "infinite";
      moncercleS4.style.animationPlayState = "running";
    }, 5000);
  });

  //Third Circles

  moncercleP1.style.animationIterationCount = "1";
  moncercleP1.addEventListener("animationend", function () {
    moncercleP1.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleP1.style.animationIterationCount = "infinite";
      moncercleP1.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleP2.style.animationIterationCount = "1";
  moncercleP2.addEventListener("animationend", function () {
    moncercleP2.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleP2.style.animationIterationCount = "infinite";
      moncercleP2.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleP3.style.animationIterationCount = "1";
  moncercleP3.addEventListener("animationend", function () {
    moncercleP3.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleP3.style.animationIterationCount = "infinite";
      moncercleP3.style.animationPlayState = "running";
    }, 5000);
  });

  moncercleP4.style.animationIterationCount = "1";
  moncercleP4.addEventListener("animationend", function () {
    moncercleP4.style.animationPlayState = "paused";
    setTimeout(function () {
      moncercleP4.style.animationIterationCount = "infinite";
      moncercleP4.style.animationPlayState = "running";
    }, 5000);
  });
  //Fourth Circles
}

startAnimation();
setInterval(function () {
  //First Circles
  moncercleC1.style.animationIterationCount = "1";
  moncercleC2.style.animationIterationCount = "1";
  moncercleC3.style.animationIterationCount = "1";
  moncercleC4.style.animationIterationCount = "1";
  //Seconde Circles
  moncercleS1.style.animationIterationCount = "1";
  moncercleS2.style.animationIterationCount = "1";
  moncercleS3.style.animationIterationCount = "1";
  moncercleS4.style.animationIterationCount = "1";
  //Third Circles
  moncercleP1.style.animationIterationCount = "1";
  moncercleP2.style.animationIterationCount = "1";
  moncercleP3.style.animationIterationCount = "1";
  moncercleP4.style.animationIterationCount = "1";
  //Fourth Circles
  setTimeout(function () {
    startAnimation();
  }, 1000);
}, 6000);

//=================================================//
//
//================================================//
//Response 1
const response1 = document.getElementsByName("response1");

// Get the select tag
const selectTag1 = document.getElementById("00N4x00000bTvrd");

// Add an event listener to the radio buttons
for (let i = 0; i < response1.length; i++) {
  response1[i].addEventListener("click", function () {
    // Get the value of the selected radio button
    const selectedOption = document.querySelector(
      'input[name="response1"]:checked'
    ).value;

    // Set the selected option in the select tag
    selectTag1.value = selectedOption;
  });
}
//Response 2
const response2 = document.getElementsByName("reponse2");
const selectTag2 = document.getElementById("00N4x00000bTvrb");
for (let i = 0; i < response2.length; i++) {
  response2[i].addEventListener("click", function () {
    const selectedOption = document.querySelector(
      'input[name="reponse2"]:checked'
    ).value;
    selectTag2.value = selectedOption;
  });
}
//Response 3
const response3 = document.getElementsByName("response3");
const selectTag3 = document.getElementById("00N4x00000bTvrc");
for (let i = 0; i < response3.length; i++) {
  response3[i].addEventListener("click", function () {
    const selectedOption = document.querySelector(
      'input[name="response3"]:checked'
    ).value;
    selectTag3.value = selectedOption;
  });
}

const response4 = document.getElementsByName("response4");
const selectTag4 = document.getElementById("00N4x00000bTvrZ");
for (let i = 0; i < response4.length; i++) {
  response4[i].addEventListener("click", function () {
    const selectedOption = document.querySelector(
      'input[name="response4"]:checked'
    ).value;
    selectTag4.value = selectedOption;
  });
}

const response5 = document.getElementsByName("response5");
const selectTag5 = document.getElementById("00N4x00000bTvra");
for (let i = 0; i < response5.length; i++) {
  response5[i].addEventListener("click", function () {
    const selectedOption = document.querySelector(
      'input[name="response5"]:checked'
    ).value;
    selectTag5.value = selectedOption;
  });
}

const response6 = document.getElementsByName("response6");
const selectTag6 = document.getElementById("00N4x00000bTvrY");
for (let i = 0; i < response6.length; i++) {
  response6[i].addEventListener("click", function () {
    const selectedOption = document.querySelector(
      'input[name="response6"]:checked'
    ).value;
    selectTag6.value = selectedOption;
  });
}

// const selectTag7 = document.getElementById("recordType");
// selectTag7.value = "0124x000000hWG4";